import { render } from "./switch.vue?vue&type=template&id=4ddf677a&lang=pug"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"
script.render = render

export default script